import type { HiddenElementsApi } from './hiddenElementsApi';
import type { PublicSlotKey } from '#packages/apilib';

export const HiddenElementsApiKey: PublicSlotKey<HiddenElementsApi> = {
  name: 'HiddenElementsApi',
  public: true,
};
